import { Modal, SaveBar, TitleBar, useAppBridge } from '@shopify/app-bridge-react';
import { useEffect, useState } from 'react';

const ModalOnpageCreateBlog = ({
  isFromPage,
  handleModalCustomizeState,
  handleModalCustomizeData,
}) => {

  // Shopify 属性
  const shopify = useAppBridge();

  const [editState, setEditState] = useState(false); // 是否可以操作
  const [barState, setBarState] = useState(false);   // 是否显示了保存bar

  // 关闭弹窗
  const modalHideAction = () => {
    handleModalCustomizeState(false, isFromPage === 'keywords' ? "/keywordRearch/keywords-data" : "/on-page-seo", "OnpageBlog_Modal");  // 回退指定页面
  }

  // 舍弃保存
  const handleDiscard = () => {
    if (editState) {
      shopify.saveBar.hide('SaveBarMax_OnpageBlog');
      handleModalCustomizeData('discard', "OnpageBlog_Modal");
      setBarState(false);
    }
  };

  // 内容保存
  const handleSave = () => {
    if (editState) {
      handleModalCustomizeData('save', "OnpageBlog_Modal");
    }
  }

  // 接收子窗口
  const handleFromModalOnpageBlog = (ev) => {
    const _that = ev.data;
    if (_that?.page === "Edit") {
      const _type = _that?.mode || '';
      if (_type === "save") {
        // 保存
        shopify.saveBar.hide('SaveBarMax_OnpageBlog');
        setBarState(false);
      } else if (_type === "showSavebar") {
        // 显示保存bar
        setEditState(true);
        // 判断是否显示了
        if (!barState) {
          shopify.saveBar.show("SaveBarMax_OnpageBlog");
          setBarState(true);
        }
      } else if (_type === "hideSavebar") {
        shopify.saveBar.hide("SaveBarMax_OnpageBlog");
        // 显示发布
        setBarState(false);
      } else { }
    }
  }

  useEffect(() => {
    window.addEventListener('message', handleFromModalOnpageBlog)
    return () => {
      window.removeEventListener('message', handleFromModalOnpageBlog)
    }
  }, [])

  // 弹窗模块
  return (
    <Modal id="OnpageBlog_Modal" src={"/on-page-seo/generate-blog"} variant={"max"} onHide={modalHideAction}>
      <TitleBar title={"SEOAnt - Generate Blog"} />
      <SaveBar id="SaveBarMax_OnpageBlog" discardConfirmation="">
        <button onClick={handleDiscard}></button>
        <button variant="primary" onClick={handleSave}></button>
      </SaveBar>
    </Modal>
  )

}

export default ModalOnpageCreateBlog;